import { SKIPPED_SEAT_SELECTION } from "@hopper-b2b/types";
import { trackBaseEvent } from "../utils";

export const trackSkipSeatSelection = async (context) =>
  trackBaseEvent(context, {
    eventName: SKIPPED_SEAT_SELECTION,
    properties: {},
  });
